<template>
  <div>
   <!-- 增值税发票开票信息 -->
   <div class="detailsTitle">
      <h4>开票信息</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
    <div class='detilTop'>
      <p>增值税发票开票信息&nbsp;&nbsp;&nbsp;&nbsp;
        <span><el-button type="primary" size='mini' @click="changeDetilCilck" v-if="changeInvoiceBtn">编辑</el-button></span>
        <span><el-button type="primary" size='mini' @click="addDetilCilck" v-if="addInvoiceBtn">新增</el-button></span>
      </p>
      <p>单位名称：<span>{{detilData.companyName}}</span></p>
      <p>纳税人识别号：<span>{{detilData.taxpayerNumber}}</span></p>
      <p>注册地址：<span>{{detilData.registAddress}}</span></p>
      <p>注册电话：<span>{{detilData.registPhone}}</span></p>
      <p>开户行：<span>{{detilData.openingBank}}</span></p>
      <p>账号：<span>{{detilData.bankAccount}}</span></p>
    </div>
    <el-divider></el-divider>
    <!-- 修改开票信息弹窗 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeiInvoiceDetilMark"
    width="800px"
    center>
      <span >
         <el-form
          :model="changeiInvoiceDetilFrom"
          ref="changeiInvoiceDetilFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item  label="单位名称"
            prop='companyName'
            style="margin-top:20px;">
            <el-input v-model="changeiInvoiceDetilFrom.companyName" maxlength="20" style="width:210px;" :validate-event = "false"></el-input>
          </el-form-item>
          <el-form-item  label="纳税人识别号"
            prop='taxpayerNumber'
            style="margin-top:20px;">
            <el-input v-model="changeiInvoiceDetilFrom.taxpayerNumber" maxlength="20"  style="width:210px;" :validate-event = "false" ></el-input>
          </el-form-item>
          <el-form-item  label="注册地址"
            prop='registAddress'
            style="margin-top:20px;">
            <el-input v-model="changeiInvoiceDetilFrom.registAddress" style="width:210px;" maxlength=""  :validate-event = "false"></el-input>
          </el-form-item>
          <el-form-item  label="注册电话"
            prop='registPhone'
            style="margin-top:20px;">
            <el-input  v-model="changeiInvoiceDetilFrom.registPhone"  style="width:210px;" maxlength="20"  :validate-event = "false"></el-input>
          </el-form-item>
          <el-form-item  label="开户银行"
            prop='openingBank'
            style="margin-top:20px;">
            <el-input v-model="changeiInvoiceDetilFrom.openingBank" style="width:210px;" maxlength="" :validate-event = "false"></el-input>
          </el-form-item>
          <el-form-item  label="银行账号"
            prop='bankAccount'
            style="margin-top:20px;">
            <el-input  placeholder="" maxlength=""  v-model="changeiInvoiceDetilFrom.bankAccount" :validate-event = "false" onkeyup="value=value.replace(/\D/g,'').replace(/....(?!$)/g,'$& ')" style="width:210px;"></el-input>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'   @click="addInvoiceDetilSubmit('changeiInvoiceDetilFrom')" :loading="addLoadding" v-if="addBCbtn" >保存</el-button>
        <el-button type="primary" size='mini'   @click="addInvoiceDetilSubmit('changeiInvoiceDetilFrom')" :loading="changeLoadding" v-if="changeBCbtn" >保存</el-button>
        <el-button @click="changeiInvoiceDetilClose('changeiInvoiceDetilFrom')" size='mini'>取消</el-button>
      </span>
    </el-dialog>
    <!-- 发票收票地址 -->
    <div class='detilTop'>
      <p>发票收票地址&nbsp;&nbsp;&nbsp;&nbsp;
        <span><el-button type="primary" size='mini' @click="addCollectionCilck" v-if="addInvoiceBtn2">新增</el-button></span>
        <span><el-button type="primary" size='mini' @click="changeCollectionCilck" v-if="changeInvoiceBtn2">编辑</el-button></span>
      </p>
      <p>收票人姓名：<span>{{detilData.receiveName}}</span></p>
      <p>联系电话：<span>{{detilData.receiveTel}}</span></p>
      <p>电子邮箱：<span>{{detilData.receiveEmail}}</span></p>
      <p>收票地址：<span>{{detilData.province}}{{detilData.city}}{{detilData.area}}{{detilData.address}}</span></p>
    </div>
    <!-- <el-button type="primary" size='mini' style="margin-left:25px;">返回</el-button> -->
    <!-- 修改收票信息弹窗 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeCollectionMark"
    width="800px"
    center>
      <span>
         <el-form
          :model="changeCollectionFrom"
          ref="changeCollectionFrom"
          :rules="rules1"
          :validate-on-rule-change = "false"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item  label="收票人姓名"
            prop='receiveName'
            style="margin-top:20px;">
            <el-input v-model="changeCollectionFrom.receiveName" maxlength="20" style="width:210px;" ></el-input>
          </el-form-item>
          <!-- onkeyup="var reg = /^[\d\_a-zA-Z]+$/;if(!reg.test(this.value)) this.value='';" -->
          <el-form-item  label="联系电话"
            prop='receiveTel'
            style="margin-top:20px;">
            <el-input v-model="changeCollectionFrom.receiveTel" maxlength="12"  style="width:210px;" ></el-input>
          </el-form-item>
          <el-form-item  label="电子邮箱"
            prop='receiveEmail'
            style="margin-top:20px;">
            <el-input v-model="changeCollectionFrom.receiveEmail" style="width:210px;" maxlength="" ></el-input>
          </el-form-item>
          <el-form-item label="收货地址:"  class="diqu is-required" style="margin-top:20px;">
                 <el-form-item prop="areaCode1">
                   <el-cascader  :options="options" v-model="changeCollectionFrom.areaCode1"  @change="handleChange"></el-cascader>
                 </el-form-item>
                 <el-form-item prop="address" style="margin-top:20px;">
                   <el-input maxlength=""   v-model="changeCollectionFrom.address" style="width:280px;" placeholder="详细地址"></el-input>
                </el-form-item>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'   @click="addCollectionSubmit('changeCollectionFrom')" :loading="addLoadding2" v-if="addBCbtn2">保存</el-button>
        <el-button type="primary" size='mini'   @click="addCollectionSubmit('changeCollectionFrom')" :loading="changeLoadding2" v-if="changeBCbtn2" >保存</el-button>
        <el-button @click="changeCollectionClose('changeCollectionFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <!-- <div style="margin:10px 0 0 30px;">
      <el-button type="primary" @click="backTo" size='mini'>返回</el-button>
    </div> -->
  </div>
</template>
<script>
import {
  getInvoiceModelDetail, // 查询
  addReceipt, // 新增
  updateReceipt, // 修改
  addAddress, // 新增收票
  updateAddress // 修改收票
} from '@/api/consignment'
import DonMessage from '@/utils/message'
// import { getBtn } from '@/utils/getButton'
import { regionData, CodeToText } from 'element-china-area-data'
export default {
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号或座机号不能为空'))
      } else {
        // 手机或固定电话
        // const mobile = /^1[0-9]{10}$/; const phone = /^0\d{2,3}-?\d{7,8}$/
        const mobile = /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/
        if (mobile.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号或座机号'))
        }
      }
    }
    return {
      title: '',
      // 开票
      addInvoiceBtn: false,
      changeInvoiceBtn: false,
      addInvoiceBtn2: false,
      changeInvoiceBtn2: false,
      addBCbtn: false,
      changeBCbtn: false,
      addLoadding: false,
      changeLoadding: false,
      addLoadding2: false,
      changeLoadding2: false,
      addBCbtn2: false,
      changeBCbtn2: false,
      changeiInvoiceDetilMark: false,
      detilData: {},
      changeiInvoiceDetilFrom: {
        companyName: '',
        taxpayerNumber: '',
        registAddress: '',
        registPhone: '',
        openingBank: '',
        bankAccount: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        taxpayerNumber: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        registAddress: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        registPhone: [
          // { required: true, message: '请输入注册电话', trigger: 'blur' },
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        openingBank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ]
      },
      // 收票
      changeCollectionMark: false,
      changeCollectionFrom: {
        id: '',
        receiveName: '',
        receiveTel: '',
        receiveEmail: '',
        province: '',
        city: '',
        area: '',
        provincecode: '',
        citycode: '',
        areacode: '',
        address: ''
      },
      rules1: {
        receiveName: [
          { required: true, message: '请输入收票人姓名', trigger: 'blur' }
        ],
        receiveTel: [
          // { required: true, message: '请输入联系电话', trigger: 'blur' },
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        receiveEmail: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' }
        ],
        areaCode1: [
          { required: true, message: '请选择省市县', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      options: regionData,
      bigData: {}
    }
  },
  mounted () {
    // let h = this.$refs.searchBox.offsetHeight
    // let pH = document.documentElement.clientHeight
    // this.h = (pH - h - 92) + 'px'
  },
  created () {
    this.getDetail()
  },
  methods: {
    // 查询接口
    getDetail () {
      getInvoiceModelDetail().then(res => {
        this.bigData = res
        if (res === null) {
          this.addInvoiceBtn = true
          this.changeInvoiceBtn = false
          this.addInvoiceBtn2 = true
          this.changeInvoiceBtn2 = false
        } else {
          this.addInvoiceBtn = false
          this.changeInvoiceBtn = true
          this.addInvoiceBtn2 = false
          this.changeInvoiceBtn2 = true
          this.detilData = res
          if (this.detilData.companyName == '') {
            this.addInvoiceBtn = true
            this.changeInvoiceBtn = false
          } else {
            this.addInvoiceBtn = false
            this.changeInvoiceBtn = true
          }
          if (this.detilData.receiveName == '') {
            this.addInvoiceBtn2 = true
            this.changeInvoiceBtn2 = false
          } else {
            this.addInvoiceBtn2 = false
            this.changeInvoiceBtn2 = true
          }
        }
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 地区选中
    handleChange (value) {
      // if (value) {
      //   this.addFrom.areaName = CodeToText[value[0]] + CodeToText[value[1]] + CodeToText[value[2]]
      // }
      if (value) {
        this.changeCollectionFrom.provincecode = value[0]
        this.changeCollectionFrom.citycode = value[1]
        this.changeCollectionFrom.areacode = value[2]
        this.changeCollectionFrom.province = CodeToText[value[0]]
        this.changeCollectionFrom.city = CodeToText[value[1]]
        this.changeCollectionFrom.area = CodeToText[value[2]]
        // console.log(this.changeCollectionFrom.province, this.changeCollectionFrom.city, this.changeCollectionFrom.area, '222')
      }
    },
    // 点击新增开票信息
    addDetilCilck () {
      this.changeiInvoiceDetilMark = true
      this.title = '新增开票信息'
      this.addBCbtn = true
      this.changeBCbtn = false
    },
    // 点击修改开票信息
    changeDetilCilck () {
      this.changeiInvoiceDetilMark = true
      this.title = '修改开票信息'
      this.addBCbtn = false
      this.changeBCbtn = true
      this.changeiInvoiceDetilFrom.companyName = this.detilData.companyName
      this.changeiInvoiceDetilFrom.taxpayerNumber = this.detilData.taxpayerNumber
      this.changeiInvoiceDetilFrom.registAddress = this.detilData.registAddress
      this.changeiInvoiceDetilFrom.registPhone = this.detilData.registPhone
      this.changeiInvoiceDetilFrom.openingBank = this.detilData.openingBank
      this.changeiInvoiceDetilFrom.bankAccount = this.detilData.bankAccount
    },
    // 新增
    addInvoiceDetilSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.bigData == null || this.detilData == null) {
            this.addLoadding = true
            addReceipt(this.changeiInvoiceDetilFrom).then(res => {
              DonMessage.success('添加成功')
              this.addLoadding = false
              this.changeiInvoiceDetilMark = false
              this.getDetail()
            }).catch(err => {
              this.addLoadding = false
              DonMessage.error(err.message)
            })
          } else if (this.bigData != null || this.detilData != null) {
            this.changeLoadding = true
            updateReceipt({
              id: this.detilData.id,
              companyName: this.changeiInvoiceDetilFrom.companyName,
              taxpayerNumber: this.changeiInvoiceDetilFrom.taxpayerNumber,
              registAddress: this.changeiInvoiceDetilFrom.registAddress,
              registPhone: this.changeiInvoiceDetilFrom.registPhone,
              openingBank: this.changeiInvoiceDetilFrom.openingBank,
              bankAccount: this.changeiInvoiceDetilFrom.bankAccount
            }).then(res => {
              DonMessage.success('修改成功')
              this.changeLoadding = false
              this.changeiInvoiceDetilMark = false
              this.getDetail()
            }).catch(err => {
              this.changeLoadding = false
              DonMessage.error(err.message)
            })
          }
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 修改开票信息关闭
    changeiInvoiceDetilClose (formName) {
      this.changeiInvoiceDetilMark = false
      this.$refs[formName].resetFields()
    },
    // 新增收票
    addCollectionCilck () {
      this.addBCbtn2 = true
      this.changeBCbtn2 = false
      this.changeCollectionMark = true
      this.title = '新增收票信息'
    },
    // 点击修改收票信息按钮
    changeCollectionCilck () {
      this.changeCollectionMark = true
      this.addBCbtn2 = false
      this.changeBCbtn2 = true
      this.title = '修改收票信息'
      this.changeCollectionFrom.receiveName = this.detilData.receiveName
      this.changeCollectionFrom.receiveTel = this.detilData.receiveTel
      this.changeCollectionFrom.receiveEmail = this.detilData.receiveEmail
      this.changeCollectionFrom.address = this.detilData.address
      this.changeCollectionFrom = JSON.parse(JSON.stringify(this.detilData))
      if (this.detilData.city && !this.detilData.area) {
        this.$set(this.changeCollectionFrom, 'areaCode1', [this.detilData.provincecode, this.detilData.citycode])
      } else if (!this.detilData.city && !this.detilData.area) {
        this.$set(this.changeCollectionFrom, 'areaCode1', [this.detilData.provincecode])
      } else {
        this.$set(this.changeCollectionFrom, 'areaCode1', [this.detilData.provincecode, this.detilData.citycode, this.detilData.areacode])
      }
      console.log(this.detilData.provincecode, this.detilData.citycode)
    },
    // 新增收票
    addCollectionSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          if (this.bigData == null || this.detilData == null) {
            this.addeLoadding2 = true
            addAddress(this.changeCollectionFrom).then(res => {
              DonMessage.success('新增成功')
              this.addeLoadding2 = false
              this.changeCollectionMark = false
              this.getDetail()
            }).catch(err => {
              this.addeLoadding2 = false
              DonMessage.error(err.message)
            })
          } else if (this.bigData != null || this.detilData != null) {
            this.changeLoadding2 = true
            updateAddress({
              id: this.detilData.id,
              receiveName: this.changeCollectionFrom.receiveName,
              receiveTel: this.changeCollectionFrom.receiveTel,
              receiveEmail: this.changeCollectionFrom.receiveEmail,
              province: this.changeCollectionFrom.province,
              city: this.changeCollectionFrom.city,
              area: this.changeCollectionFrom.area,
              address: this.changeCollectionFrom.address,
              provincecode: this.changeCollectionFrom.provincecode,
              citycode: this.changeCollectionFrom.citycode,
              areacode: this.changeCollectionFrom.areacode
            }).then(res => {
              DonMessage.success('修改成功')
              this.changeLoadding2 = false
              this.changeCollectionMark = false
              this.getDetail()
            }).catch(err => {
              this.changeLoadding2 = false
              DonMessage.error(err.message)
            })
          }
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 修改收票信息关闭
    changeCollectionClose (formName) {
      this.changeCollectionMark = false
      this.$refs[formName].resetFields()
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 返回
    backTo () {
      this.$router.push('/payCustomer/invoiceApply')
    }
  }
}
</script>
<style scoped lang='less'>
.detilTop{
  padding: 0 0 0 30px;
}
</style>
